// import React, { useContext, useState } from "react";
// import axios from "axios";
// import { toast } from "react-hot-toast";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const { login: loginContext } = useContext(AuthContext);

//   const [data, setData] = useState({
//     email: "",
//     password: "",
//   });

//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const handleChange = ({ currentTarget: input }) => {
//     setData({ ...data, [input.name]: input.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // const url = "http://localhost:8081/api/login";
//       const url = "https://api.rangpurgolf.com/api/login";
//       const res = await axios.post(url, data, {
//         withCredentials: true, // very important for cookie
//       });

//       // Access token from response body
//       // localStorage.setItem("token", res.data.accessToken);
//       localStorage.setItem("memberEmail", res.data.email);
//       // localStorage.setItem("role", res.data.role);
//       localStorage.setItem("dashboardLocked", res.data.dashboardLocked);

//       // Update context state
//       loginContext(res.data.accessToken);

//       toast.success("Login successful!");
//       navigate("/dashboard");
//     } catch (error) {
//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("Login failed. Please try again.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-[#fffdf7] min-h-screen flex items-center justify-center px-4">
//       <div className="w-full max-w-md bg-[#fcfaec] p-8 rounded-xl shadow-md">
//         <h1 className="text-3xl font-bold text-center text-black mb-8">
//           Login
//         </h1>

//         <form className="space-y-5" onSubmit={handleSubmit}>
//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={data.email}
//               onChange={handleChange}
//               required
//               className="w-full p-3 rounded bg-white outline-none"
//               placeholder="example@email.com"
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Password
//             </label>
//             <input
//               type="password"
//               name="password"
//               onChange={handleChange}
//               value={data.password}
//               required
//               className="w-full p-3 rounded bg-white outline-none"
//               placeholder="••••••••"
//             />
//           </div>

//           <div className="flex items-center justify-between text-sm">
//             <Link
//               to="/forgot-password"
//               className="text-lime-600 hover:underline"
//               title="Click here to reset your password"
//             >
//               Forgot password?
//             </Link>
//             <Link
//               to="/membership-registration"
//               className="text-lime-600 hover:underline"
//               title="Click here to register"
//             >
//               Not a member yet?
//             </Link>
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full py-3 uppercase rounded-full font-bold text-black bg-lime-400 hover:bg-black hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;
// import React, { useContext, useState } from "react";
// // import axios from "axios";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";
// import { useNavigate, Link } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const { login: loginContext } = useContext(AuthContext);
//   const [data, setData] = useState({ email: "", password: "" });
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = ({ currentTarget: input }) =>
//     setData({ ...data, [input.name]: input.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const res = await api.post(
//         // "http://localhost:8081/api/member/login",
//         "/member/login",
//         data,
//         { withCredentials: true }
//       );

//       // Save member info & access token
//       localStorage.setItem("token", res.data.accessToken);
//       localStorage.setItem("memberEmail", res.data.email);
//       localStorage.setItem("dashboardLocked", res.data.dashboardLocked);
//       localStorage.setItem("role", res.data.role);

//       loginContext(res.data.accessToken);

//       toast.success("Login successful!");
//       navigate("/dashboard");
//     } catch (error) {
//       const message =
//         error.response?.data?.message ||
//         "Login failed. Please check your credentials.";
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-[#fffdf7] min-h-screen flex items-center justify-center px-4">
//       <div className="w-full max-w-md bg-[#fcfaec] p-8 rounded-xl shadow-md">
//         <h1 className="text-3xl font-bold text-center text-black mb-8">
//           Login
//         </h1>
//         <form className="space-y-5" onSubmit={handleSubmit}>
//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={data.email}
//               onChange={handleChange}
//               required
//               className="w-full p-3 rounded bg-white outline-none"
//               placeholder="example@email.com"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Password
//             </label>
//             <input
//               type="password"
//               name="password"
//               value={data.password}
//               onChange={handleChange}
//               required
//               className="w-full p-3 rounded bg-white outline-none"
//               placeholder="••••••••"
//             />
//           </div>
//           <div className="flex items-center justify-between text-sm">
//             <Link
//               to="/forgot-password"
//               className="text-lime-600 hover:underline"
//             >
//               Forgot password?
//             </Link>
//             <Link
//               to="/membership-registration"
//               className="text-lime-600 hover:underline"
//             >
//               Not a member yet?
//             </Link>
//           </div>
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full py-3 uppercase rounded-full font-bold text-black bg-lime-400 hover:bg-black hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

// pages/Login.js
// import React, { useContext, useState } from "react";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";
// import { useNavigate, Link } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const { login: loginContext } = useContext(AuthContext);
//   const [data, setData] = useState({ email: "", password: "" });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleChange = ({ currentTarget: input }) => {
//     setData({ ...data, [input.name]: input.value });
//     // Clear error when user starts typing
//     if (error) setError("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     // Basic validation
//     if (!data.email || !data.password) {
//       setError("Please fill in all fields");
//       setLoading(false);
//       return;
//     }

//     try {
//       const res = await api.post("/member/login", data, {
//         withCredentials: true,
//       });

//       // Save member info & access token
//       localStorage.setItem("token", res.data.accessToken);
//       localStorage.setItem("memberEmail", res.data.email);
//       localStorage.setItem("dashboardLocked", res.data.dashboardLocked);
//       localStorage.setItem("role", res.data.role);

//       loginContext(res.data.accessToken);

//       toast.success("Login successful!");
//       navigate("/dashboard");
//     } catch (error) {
//       const message =
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please check your credentials.";

//       setError(message);
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-[#fffdf7] min-h-screen flex items-center justify-center px-4">
//       <div className="w-full max-w-md bg-[#fcfaec] p-8 rounded-xl shadow-md">
//         <h1 className="text-3xl font-bold text-center text-black mb-8">
//           Login
//         </h1>

//         {/* Error Message */}
//         {error && (
//           <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
//             {error}
//           </div>
//         )}

//         <form className="space-y-5" onSubmit={handleSubmit}>
//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={data.email}
//               onChange={handleChange}
//               required
//               className={`w-full p-3 rounded bg-white outline-none border ${
//                 error ? "border-red-300" : "border-gray-300"
//               }`}
//               placeholder="example@email.com"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-black mb-1">
//               Password
//             </label>
//             <input
//               type="password"
//               name="password"
//               value={data.password}
//               onChange={handleChange}
//               required
//               className={`w-full p-3 rounded bg-white outline-none border ${
//                 error ? "border-red-300" : "border-gray-300"
//               }`}
//               placeholder="••••••••"
//             />
//           </div>
//           <div className="flex items-center justify-between text-sm">
//             <Link
//               to="/forgot-password"
//               className="text-lime-600 hover:underline"
//             >
//               Forgot password?
//             </Link>
//             <Link
//               to="/membership-registration"
//               className="text-lime-600 hover:underline"
//             >
//               Not a member yet?
//             </Link>
//           </div>
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full py-3 uppercase rounded-full font-bold text-black bg-lime-400 hover:bg-black hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;
// pages/Login.js
import React, { useContext, useState } from "react";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const { login: loginContext } = useContext(AuthContext);
  const [data, setData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });
    // Clear error when user starts typing
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Basic validation
    if (!data.email || !data.password) {
      setError("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const res = await api.post("/member/login", data, {
        withCredentials: true,
      });

      // Save member info & access token
      localStorage.setItem("token", res.data.accessToken);
      localStorage.setItem("memberEmail", res.data.email);
      localStorage.setItem("dashboardLocked", res.data.dashboardLocked);
      localStorage.setItem("role", res.data.role);

      loginContext(res.data.accessToken);

      toast.success("Login successful!");
      navigate("/dashboard");
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please check your credentials.";

      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bg-[#fffdf7] min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#fcfaec] p-8 rounded-xl shadow-md">
        <h1 className="text-3xl font-bold text-center text-black mb-8">
          Login
        </h1>

        {/* Error Message */}
        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}

        <form className="space-y-5" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-black mb-1">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
              className={`w-full p-3 rounded bg-white outline-none border ${
                error ? "border-red-300" : "border-gray-300"
              }`}
              placeholder="example@email.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-black mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={data.password}
                onChange={handleChange}
                required
                className={`w-full p-3 pr-10 rounded bg-white outline-none border ${
                  error ? "border-red-300" : "border-gray-300"
                }`}
                placeholder="••••••••"
              />
              {/* Eye Icon Button */}
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  // Eye open icon (visible)
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                ) : (
                  // Eye closed icon (hidden)
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between text-sm">
            <Link
              to="/forgot-password"
              className="text-lime-600 hover:underline"
            >
              Forgot password?
            </Link>
            <Link
              to="/membership-registration"
              className="text-lime-600 hover:underline"
            >
              Not a member yet?
            </Link>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 uppercase rounded-full font-bold text-black bg-lime-400 hover:bg-black hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
